import React from 'react';
import FileUpload from '../../files/FileUpload';
import { injectIntl } from 'react-intl';
import {messages} from  '../../common/Translations'

class ValidatedFileInput extends React.Component {
    constructor(props) {
        super(props);
        // props.label === undefined ? this.intl.formatMessage(messages.catalogInputTitle)
    }

    renderError(type) {
        if (this.canShowError(type)) {

            return (
                <div className={'form-control-feedback error-block'}>
                    {this.error}
                </div>
            );
        }
        return null;
    }

    canShowError() {
        if (this.props.files.meta.error && this.props.files.meta.touched) {
            this.error = this.props.files.meta.error;
            return true;
        }
        if (this.props.defaultFiles.meta.error && this.props.defaultFiles.meta.touched) {
            this.error = this.props.defaultFiles.meta.error;
            return true;
        }
        if (this.props.defaultFileIds.meta.error && this.props.defaultFileIds.meta.touched) {
            this.error = this.props.defaultFileIds.meta.error;
            return true;
        }

        return false;
    }

    applyErrorClass() {
        return this.canShowError() ? 'has-danger' : '';
    }

    render() {

        let fileSizeLimit = (MAX_FILE_SIZE > 1) ? MAX_FILE_SIZE - 1 : 1;

        return (
            <div className={`form-group row ${this.applyErrorClass()}`} id={`div_${this.props.files.input.name}`}>
                <label className="col-sm-2 col-form-label"><b>{this.props.intl.formatMessage(messages.catalogFile)}</b><small className="form-text text-muted">
                {`${this.props.intl.formatMessage(messages.filesMaxSize)} ${fileSizeLimit} MB.`}
                </small></label>
                <div className="col-sm-10">
                    <FileUpload
                        files={this.props.files}
                        defaultFiles={this.props.defaultFiles}
                        defaultFileIds={this.props.defaultFileIds}
                        type={this.props.type}
                        postUrl={this.props.postUrl}
                        maxFiles={this.props.maxFiles}
                    />

                    <p className="text-muted">PDF. DOC. ZIP Max {`${MAX_FILE_SIZE - 1}`} mb.</p>
                    <div className="form-control-feedback">
                        {this.renderError()}
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(ValidatedFileInput);



// WEBPACK FOOTER //
// ./web/src/components/common/form/ValidatedFileInput.jsx